<template>
  <v-text-field
    v-bind="$attrs"
    autocomplete="off"
    placeholder="mm/dd/yyyy"
    label="Date of Birth"
    :rules="rules"
    :required="required"
    :outlined="outlined"
    :dense="dense"
    :rounded="rounded"
    :disabled="disabled"
    v-model="internvalValue"
    @keydown="checkKey"
    @keyup="normalizeSlash"
    @blur="normalizeYear" />
</template>
<script>
export default {
  inheritAttrs: false,
  props: [
    'value',
    'required',
    'outlined',
    'dense',
    'rounded',
    'disabled',
    'rules',
  ],
  data() {
    return {
      internvalValue: '',
      functionalKeys: [
        'Backspace',
        'Delete',
        'ArrowLeft',
        'ArrowRight',
        'Tab',
      ],
    };
  },
  methods: {
    checkKey(evt) {
      const isInvalidValidKey = !this.functionalKeys.includes(evt.key) && (!/[0-9/]/.test(evt.key) || this.internvalValue.length >= 10);
      const isInvalidDoubleSlash = evt.key === '/' && this.internvalValue[this.internvalValue.length - 1] === '/';
      if (isInvalidValidKey || isInvalidDoubleSlash) {
        evt.preventDefault();
      }
    },
    normalizeSlash(evt) {
      if (evt.key === 'Backspace') {
        if (this.internvalValue[this.internvalValue.length - 1] === '/') {
          this.internvalValue = this.internvalValue.substring(0, this.internvalValue.length - 1);
        }
      } else {
        const [, month, slash1, day, slash2, year] = /(\d{0,2})(\/?)(\d{0,2})(\/?)(\d{0,4})/.exec(this.internvalValue);

        let normalizedMonth = month;
        if (month.length === 1 && slash1) {
          normalizedMonth = this.padField(month);
        }

        let normalizedDay = day;
        if (day.length === 1 && slash2) {
          normalizedDay = this.padField(day);
        }

        this.internvalValue = `${normalizedMonth}${slash1 || day ? '/' : ''}${normalizedDay}${slash2 || year ? '/' : ''}${year}`;
      }

      this.$emit('input', this.internvalValue);
    },
    normalizeYear() {
      const [, month, slash1, day, slash2, year] = /(\d{0,2})(\/?)(\d{0,2})(\/?)(\d{0,4})/.exec(this.internvalValue);

      let normalizedYear = year;
      if (year && year.length === 2) {
        const yearAfterCentury = new Date().getFullYear() % 100;
        if (Number(year) <= yearAfterCentury) {
          normalizedYear = `20${this.padField(year)}`;
        } else {
          normalizedYear = `19${this.padField(year)}`;
        }
      }

      this.internvalValue = `${month}${slash1 || day ? '/' : ''}${day}${slash2 || normalizedYear ? '/' : ''}${normalizedYear}`;

      this.$emit('input', this.internvalValue);
    },
    padField(value) {
      return `${value}`.padStart(2, '0');
    },
  },
  watch: {
    value() {
      if (this.value === this.internvalValue) {
        return;
      }

      let startingValue = '';
      
      if (this.value) {
        // try simple parse
        const addTail = this.value.toLowerCase().endsWith('z');
        const date = new Date(this.value + (addTail ? 'T00:00.000Z': ''));
        if (!isNaN(+date)) {
          const month = this.padField(date.getMonth() + 1);
          const day = this.padField(date.getDate());
          const year = date.getFullYear();
          startingValue = `${month}/${day}/${year}`;
        }
      }

      this.internvalValue = startingValue;
    },
  },
};
</script>
